import { HttpClient, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UpdateableList } from 'src/app/helper/updateable-list';
import {
    ConfigModel,
    ConfigModelInterface,
    ConfigModelResponse,
    ConfigValueTypeEnum,
} from 'src/app/interface/config-model.interface';
import { UserModelResponse } from 'src/app/interface/user-model.interface';

class ConfigModelList extends UpdateableList<ConfigModel> {
    public order(a: ConfigModel, b: ConfigModel) {
        if (a.id == b.id) return 0;
        return a.ident > b.ident ? 1 : -1;
    }

    public equal(a: ConfigModel, b: ConfigModel) {
        return a.id == b.id;
    }
}

@Component({
    selector: 'app-config',
    templateUrl: './config.component.html',
    styleUrls: ['./config.component.css'],
})
export class ConfigComponent implements OnInit {
    public formGroup = new FormGroup({
        value: new FormControl(),
    });

    public configs = new ConfigModelList();
    public modConfigModel?: ConfigModel;

    constructor(private httpClient: HttpClient) {}

    public columnHeadings: string[] = [
        'control',
        'id',
        'ident',
        'value',
        'description',
    ];

    ngOnInit(): void {
        let params = new HttpParams()
            .set('limit', 100)
            .set('ordering', 'ident');

        this.httpClient
            .get<ConfigModelResponse>('configs', { params: params })
            .subscribe((response: ConfigModelResponse) => {
                this.configs.data = response.results.map((m) =>
                    ConfigModel.factory(m, this.httpClient)
                );
            });
    }

    public modifyConfig(config: ConfigModel) {
        this.modConfigModel = config;
        this.formGroup.get('value')!.setValue(config.resolved_value);
    }

    public saveConfig() {
        let value = this.formGroup.get('value')!.value;

        if (this.modConfigModel!.value_type == 'OPERATOR') {
            value = this.modConfigModel!.value;
        }

        this.modConfigModel!.value = value;
        this.httpClient
            .patch<ConfigModelInterface>(
                `configs/${this.modConfigModel!.id}/`,
                {
                    value: value,
                }
            )
            .subscribe((response: ConfigModelInterface) => {
                this.configs.update(
                    ConfigModel.factory(response, this.httpClient)
                );
                this.modConfigModel = undefined;
            });
    }

    public updateOperator(user: any) {
        if (!this.modConfigModel) return;
        this.modConfigModel.value = String(user.id);
    }
}
